"use client";

import { FaSearch } from "react-icons/fa";

type GuidesSearchBarProps = {
  value: string;
  onChange: (value: string) => void;
  className?: string;
};

export function GuidesSearchBar({ value, onChange, className = "" }: GuidesSearchBarProps) {
  return (
    <div className={`relative w-full ${className}`}>
      <FaSearch
        className="pointer-events-none absolute left-5 top-1/2 -translate-y-1/2 text-[15px] text-[#1C1C1C]/55 sm:left-5"
        aria-hidden="true"
      />
      <input
        type="search"
        placeholder="Rechercher un guide, un sujet, une question..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-2xl border-2 border-zinc-200 bg-white py-3 pl-12 pr-5 text-[15px] font-medium text-[#1C1C1C] shadow-[0_10px_30px_-14px_rgba(0,0,0,0.18),inset_0_1px_0_rgba(255,255,255,1)] placeholder:font-normal placeholder:text-zinc-400 transition focus:border-[#1C1C1C] focus:bg-white focus:outline-none focus:ring-4 focus:ring-[#1C1C1C]/10 sm:pl-12 sm:text-base"
      />
    </div>
  );
}
